import React from "react";
import "./ListeningInputQuestions.css";

const GetInputQuestion = (props) => {
  let { statement, userAnswer, bulletType, questionNumber } = props;
  let splitStatement = statement.split("{input}");

  return (
    <div
      className={`listeningInputStatementContainer ${
        bulletType === "Arrow" ? "listeningInputStatementIndented" : ""
      }`}
    >
      <p
        className={`listeningInputStatementText ${
          bulletType === "Bullet"
            ? "listeningQuestionBulletPoint"
            : bulletType === "Arrow"
            ? "listeningQuestionSubBulletPoint"
            : ""
        }`}
      >
        {splitStatement[0]} <strong>({questionNumber})</strong>
      </p>
      <input
        className="listeningInputStatementInput"
        value={userAnswer}
        onChange={props.updateInputAnswer}
      />
      <p className="listeningInputStatementText">{splitStatement[1]}</p>
    </div>
  );
};

const ListeningInputQuestions = (props) => {
  return (
    <div className="listeningInputQuestionsWrapper">
      {props.content.questionList.map((question, index) => (
        <div
          className="listeningInputQuestionContainer"
          key={`inputQuestionItem - ${props.componentIndex} - ${index}`}
        >
          {question.boldText !== "" ? (
            <h3 className="listeningInputQuestionBoldText">
              {question.leftColumnText}
            </h3>
          ) : (
            <div></div>
          )}
          {question.rightColumnText.includes("{input}") ? (
            <GetInputQuestion
              statement={question.rightColumnText}
              bulletType={question.bulletType}
              questionNumber={
                props.userAnswers[question.questionId].questionNumber
              }
              userAnswer={props.userAnswers[question.questionId].answer}
              updateInputAnswer={(e) =>
                props.updateInputAnswer(e, question.questionId)
              }
            />
          ) : (
            <div
              className={`listeningInputStatementContainer ${
                question.bulletType === "Arrow"
                  ? "listeningInputStatementIndented"
                  : ""
              }`}
            >
              <p
                className={`listeningInputStatementText ${
                  question.bulletType === "Bullet"
                    ? "listeningQuestionBulletPoint"
                    : question.bulletType === "Arrow"
                    ? "listeningQuestionSubBulletPoint"
                    : ""
                }`}
              >
                {question.rightColumnText}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ListeningInputQuestions;
